import { useState } from 'react';
import { supabase } from '../lib/supabaseClient';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    setMessage('Entrando...');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setMessage(error ? error.message : '');
  }

  return (
    <main className="adminPage">
      <form className="adminCard small" onSubmit={handleSubmit}>
        <h1>Administrador</h1>
        <p>Acceso privado para mantener el catálogo.</p>
        <label>Email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required />
        <label>Contraseña</label>
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required />
        <button className="primaryButton" type="submit">Entrar</button>
        {message && <p className="message">{message}</p>}
      </form>
    </main>
  );
}
